import React, { useMemo } from 'react'
import './CollectionComponent.css'
import { useParams} from 'react-router-dom'
import { useListProductFromCollectionQuery,useShowByIdQuery } from '../../api/collection.api';
import AllProductItem from '../../common/AllProductItem/AllProductItem'
import product_banner from '../../assets/images/desktopImage_4_banner.jpg'
import product_banner_mobile from '../../assets/images/mobileImage_4.jpg'
import LoadingComponent from '../../common/Loading/Loading.component';
import CommonBanner from '../../common/CommonBanner/CommonBanner';
import SEO from '../../common/SEO/SEO';

const CollectionComponent = () => {
    const { id } = useParams();
    const {data, error, isLoading} = useListProductFromCollectionQuery(id)
    const products = useMemo(() => {
      return data?.result || [];
    }, [data]);

   const {data:collections} = useShowByIdQuery(id)
   const collectionById = collections?.result   
          
    if (isLoading) return <LoadingComponent 
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        backgroundColor: '#f9f9f9',
      }}
    />;
    if (error) return <div>Error fetching products!</div>;  

    const collectionName = collectionById?.name || "Curated Collection";
    const collectionCanonical = `https://mayawears.com.np/collection/${collectionById?.slug || id}/${id}`;

    const collectionSchema = collectionById ? {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": `${collectionCanonical}#collection`,
          "name": `${collectionName} Collection`,
          "description": `Explore the exclusive ${collectionName} collection by Maya Wears. Contemporary streetwear designed and crafted in Nepal.`,
          "url": collectionCanonical,
          "isPartOf": {
            "@type": "WebSite",
            "name": "Maya Wears",
            "url": "https://mayawears.com.np"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": `${collectionCanonical}#breadcrumb`,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://mayawears.com.np"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Collections",
              "item": "https://mayawears.com.np/all_collection"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": collectionName,
              "item": collectionCanonical
            }
          ]
        }
      ]
    } : null;

  return (
    <>
      <SEO
        title={`${collectionName} Collection`}
        description={`Explore the exclusive ${collectionName} collection by Maya Wears. Discover contemporary silhouettes, streetwear, and premium apparel in Nepal.`}
        canonical={collectionCanonical}
        keywords={`${collectionName}, Maya Wears collections, streetwear Nepal, contemporary fashion Kathmandu, buy ${collectionName} clothes`}
        schema={collectionSchema}
      />
      <CommonBanner product_banner={product_banner} product_banner_mobile={product_banner_mobile} title={`Explore ${collectionById?.name}`} subtitle="All in One Place"/>
    
      <div className="container" style={{marginTop:'50px'}}>
        <div className="maya-collection-header">
          <div className="maya-breadcrumbs">
            <span className="breadcrumb-main">{collectionById?.name}</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-sub">All Products</span>
          </div>
        </div>
        <div className="products_grid">
            {products.map((item,index)=>(
               <AllProductItem
                  key={index}
                  _id={item._id}
                  slug={item.slug}
                  images={item.media?.[0]?.url}
                  title={item.title}
                  price={item.price}
                  imageType={item.media?.[0]?.type}
              />
            ))}
          </div>
      </div>
    </>
  )
} 

export default CollectionComponent